import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from './Button';
import { t } from 'i18next';

interface InfoModalProps {
    onClose: () => void;
    show: boolean;
  }
  const InfoModal: React.FC<InfoModalProps> = ({ onClose, show }) => {
    if (!show) return null;
  
    return (
      <div className="fixed inset-0 z-40 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
        <div className="bg-white p-4 rounded-lg max-w-md w-full">
          <div className="mb-2">
            <h2 className="font-bold">Information</h2>
          </div>
          <ul>
            <li><strong>{t("instruction1bold")}</strong> {t("instruction1")}</li>
            <li><strong>{t("instruction2bold")}</strong> {t("instruction2")}</li>
            <li><strong>{t("instruction3bold")}</strong> {t("instruction3")}</li>
          </ul>
          <div className="mt-4 flex justify-center">
            <button onClick={onClose} className="px-4 py-2 bg-red-500 text-white rounded hover:bg-blue-700">{t("common.close")}</button>
            {/* <Button buttonText='Submit' onClick={onClose} /> */}
          </div>
        </div>
      </div>
    );
  };


  export default InfoModal;
    